@let corporateDesign = corporateDesignService.corporateDesign();
@let texts = textStore.texts();

<aw-dialog
  (onClose)="dialogRef.close($event)"
  [content]="content"
  [footer]="footer"
  [data]="data"
  [width]="width"
  [title]="
    texts
      | filterTexts: ERelationType.loginHeader : EEntityType.loginLogout
      | language
  "
  [fontSize]="corporateDesign.fontSizeTitle | toFontSize"
  [closingColor]="corporateDesignService.primaryColor()">
  <ng-template #content>
    <div class="flex flex-col gap-4">
      <aw-button
        id="ticket-login"
        type="button"
        [text]="
          texts
            | filterTexts: ERelationType.loginButton : EEntityType.loginLogout
            | language
        "
        (click)="login()" />
      <aw-button
        id="continue-as-guest"
        type="button"
        [style]="'primary-alt'"
        [text]="
          texts
            | filterTexts
              : ERelationType.continueAsGuest
              : EEntityType.directTicket
            | language
        "
        (click)="continueAsGuest()" />
    </div>
  </ng-template>
  <ng-template #footer />
</aw-dialog>
